import {
  GET_AUNTIES_REQUEST,
  GET_AUNTIES_SUCCESS,
} from '../constants/actionTypes';

export const getAuntiesRequest = (payload) => ({
  type: GET_AUNTIES_REQUEST,
  payload,
});

export const getAuntiesSuccess = (payload) => ({
  type: GET_AUNTIES_SUCCESS,
  payload,
});

